import { out } from "@/lib/output/out";
/** Bounded and control-character-free: an HTML error page must not be able to
 *  smuggle escape sequences into a terminal through a diagnostic. */
export function excerpt(text: string): string {
  const flattened = out.cell(text);
  return flattened.length > 200
    ? `${flattened.slice(0, 200)}\u2026`
    : flattened;
}
